import { render, staticRenderFns } from "./DatastoreView.vue?vue&type=template&id=67f022e6&"
import script from "./DatastoreView.vue?vue&type=script&lang=js&"
export * from "./DatastoreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports